import styled from "styled-components";
import Chip from "@mui/material/Chip";

export const Container = styled.div`
  height: fit-content;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 10px;
  & > .MuiChip-root {
    margin-right: 10px;
    margin-top: 10px;
  }
`;

export const StyledChip = styled(Chip)`
  & .MuiChip-deleteIcon {
    color: ${({ theme }) => {
      return theme.colors.red;
    }};
    opacity: 0.6;
  }
  & .MuiChip-deleteIcon:hover {
    color: ${({ theme }) => {
      return theme.colors.red;
    }};
    opacity :1 ;
  }
  
  }
`;
